import { _, helpers, React, ts, ui } from '_core';

import { nestedBarChartFormat } from '../../common/formatters/nested-bar-chart';
import { prepareRhDataBarChart } from '../../common/utils/signal-utils';

type ChartProps = {
  id: string;
  readOnly: boolean;
  widgetKey: string;
  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;
  returns: string;
  fullScreen: boolean;
  frequency: ts.enums.FREQUENCY_ENUM;
  title: string;
};

const Chart = ({ id, readOnly, fullScreen, loadWidgetData, returns, frequency, title }: ChartProps) => {
  const [data, setData] = React.useState<ts.types.widgets.TableData>(null);
  const [error, setError] = React.useState<ts.types.common.ApiError>(null);

  const loadData = async () => {
    try {
      const response = await loadWidgetData({
        data: {
          file: returns,
        },
      });
      if (response) setData(response.data);
    } catch (err) {
      setError(err as ts.types.common.ApiError);
    }
  };

  React.useEffect(() => {
    if (returns) loadData();
    return () => setData(null);
  }, [returns]);

  const formattedData = React.useMemo(() => {
    if (_.isNil(data)) return null;
    return prepareRhDataBarChart(nestedBarChartFormat(data, 'date'), frequency);
  }, [data, frequency]);

  return (
    <ui.NestedBarChart
      id={id}
      data={formattedData?.data}
      count={formattedData?.count}
      category="category"
      numberFormat="#.####"
      alert={error ? { type: 'error', message: helpers.parseApiError(error) } : undefined}
      fullScreen={fullScreen}
      exportTitle={title}
      readOnly={readOnly}
    />
  );
};

export default Chart;
